
const logService = {
  log (err) {
    const copy = JSON.parse(JSON.stringify(err))
    console.log(err)
    return copy
  },
  install (Vue) {
    Vue.prototype.$log = this.log
  }
}

export default logService
